
export const feasibilityColorMixin = {

    methods: {

        getFeasibilityColor(multiplier) {
            if (multiplier < 1) return "red darken-2";
            if (multiplier < 1.5) return "orange darken-1";
            if (multiplier < 2) return "orange darken-2"
            if (multiplier < 2.5) return "orange darken-3"
            if (multiplier < 3) return "yellow darken-3"

            if (multiplier > 99) return 'green';

            return "green darken-2"
        },

        calculateFeasibilityColor(matches, targetCompletes, responseRate) {

            const multiplier = this.calculateFeasibilityMultiplier(matches,targetCompletes,responseRate);

            if (matches === 0) return "red darken-2";
            if (responseRate === 0) return 'grey';

            return this.getFeasibilityColor(multiplier);
        },

        calculateFeasibilityMultiplier(matches, targetCompletes, responseRate) {
            const invitesNeeded = Math.round(targetCompletes / (responseRate / 100));
            return Math.round(matches / invitesNeeded * 100) / 10;
        },

        calculateFeasibilityMultiplierRounded(matches, targetCompletes, responseRate) {
            let multiplier = this.calculateFeasibilityMultiplier(matches, targetCompletes, responseRate)

            if (multiplier >= 10) {
                return Math.round(multiplier);
            }

            return multiplier;
        }
    }
};